import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, NavLink, useHistory } from "react-router-dom";
import "./AdminLayout.css";

import { ProgramSetupAxios } from "../../API";

const AdminLayout = (props) => {
  const history = useHistory();
  const user = useSelector((state) => state.auth.loggedInUser);
  const [accessDenied, setAccessDenied] = useState(false);
  const [offeringList, setOfferingList] = useState([]);
  const [selectedOffering, setSelectedOffering] = useState(
    0 || user.offeringId
  );
  const [selectedOfferingName, setSelectedOfferingName] = useState(
    "" || user.programName
  );

  useEffect(() => {
    console.log(user);

    if (user.roleId !== 3) {
      setAccessDenied(true);
    }
    // if user is empty, redirect to login page
    if (Object.keys(user).length === 0) {
      history.push("/login");
    }
    getAllOfferings();
  }, [user]);

  const getAllOfferings = () => {
    ProgramSetupAxios.get("/Offering/getallactiveofferings")
      .then((response) => {
        setOfferingList(response.data);
        setSelectedOffering(response.data[0].id);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const AdminHeader = () => {
    return (
      <div className="admin-header">
        <div className="header-left">
          <select
            className="form-control"
            value={selectedOffering}
            onChange={(e) => {
              setSelectedOffering(e.target.value);
              setSelectedOfferingName(e.target.programName);
            }}
          >
            {offeringList.map((offering, index) => {
              return (
                <option key={index} value={offering.id}>
                  {offering.programName}
                </option>
              );
            })}
          </select>
        </div>
        <div className="admin-profile">
          <div className="avatar">
            {Boolean(user.profileImage) && user.profileImage !== "NA" ? (
              <img
                src="https://adminlte.io/themes/v3/dist/img/user2-160x160.jpg"
                style={{ width: "100%" }}
                alt=""
              />
            ) : (
              user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase()
            )}
          </div>
          {user.firstName + " " + user.lastName}
        </div>
      </div>
    );
  };

  const AdminSidebar = () => {
    return (
      <>
        <div className="brand">Admin Panel</div>
        <div className="sidebar-content">
          <ul className="sidebar-menu">
            <li className="s-menu-item">
              <NavLink to="/admin/dashboard" className="link">
                <i className="fa fa-dashboard"></i>
                Dashboard
              </NavLink>
            </li>
            <li className="s-menu-item">
              <NavLink to="/admin/offerings" className="link">
                <i className="fa fa-list"></i>
                Offerings
              </NavLink>
            </li>
            <li className="s-menu-item">
              <NavLink to="/admin/eligiblepool" className="link">
                <i className="fa fa-users"></i>
                Eligible Pool Data
              </NavLink>
            </li>
            <li className="s-menu-item">
              <NavLink to="/admin/programSetup" className="link">
                <i className="fa fa-tasks"></i>
                SAP Users
              </NavLink>
            </li>
            <li className="s-menu-item">
              <NavLink to="/admin/missionSetup" className="link">
                <i className="fa fa-tasks"></i>
                Mission
              </NavLink>
            </li>
            
            <li className="s-menu-item">
              <NavLink to="/admin/reports" className="link">
                <i className="fa fa-tasks"></i>
                Reports
              </NavLink>
            </li>
          </ul>
        </div>
      </>
    );
  };

  return (
    <div className="admin-layout">
      <div className="sidebar">
        <AdminSidebar />
      </div>
      <div className="main-content">
        <AdminHeader />
        <div className="admin-content">
          {/* {accessDenied && <div>Access Denied</div>} */}
          {React.cloneElement(props.component, { offeringList: offeringList, selectedOffering: selectedOffering, selectedOfferingName: selectedOfferingName })}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
